import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3e4722bf"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "vip"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "user-vip"
};
const _hoisted_4 = {
  class: "user-img"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = {
  class: "cont"
};
const _hoisted_7 = {
  class: "nav"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "tab-img"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, "待开放", -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, "待开放", -1));

const _hoisted_12 = {
  class: "nav-cont"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "img"
};
const _hoisted_15 = {
  key: 1,
  class: "null-data"
};
const _hoisted_16 = {
  class: "nav"
};
const _hoisted_17 = {
  class: "tab-img"
};
const _hoisted_18 = {
  class: "nav-cont"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "img"
};
const _hoisted_21 = {
  class: "nav"
};
const _hoisted_22 = {
  class: "tab-img"
};
const _hoisted_23 = {
  class: "nav-cont"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "img"
};
import { ref } from "vue";
import router from "@/router";
import { getGlobalProperties } from "@/assets/js/utils.js";
import { useStore } from "vuex";
import { Toast } from "vant";
export default {
  __name: 'vip',

  setup(__props) {
    const store = useStore();
    const active = ref(0);
    const active1 = ref(0);
    const list = ref([]);
    const list1 = ref([]);
    const list2 = ref([]);
    const {
      getGameListApi,
      getLoginUrlApi,
      cpGetLoginUrlApi,
      cpWithdrawApi,
      qyGetLoginUrlApi
    } = getGlobalProperties().$api;
    cpWithdrawApi({
      company_id: 1
    }).then(res => {
      store.dispatch("getUserInfo");
    });

    const getGameList = () => {
      const toast = Toast.loading({
        message: "Loading...",
        forbidClick: true
      });
      getGameListApi().then(res => {
        toast.close();

        if (res.code === 0) {
          // list.value = [res.data[2], res.data[0], res.data[1]];
          list.value = [res.data[2]];
          list1.value = res.data[3];
          list2.value = res.data[4];
        }
      }).catch(() => {
        toast.close();
      });
    };

    getGameList();

    const getLoginUrl = (item, code) => {
      const toast = Toast.loading({
        message: "Loading...",
        forbidClick: true
      });
      sessionStorage.setItem("__code", code);
      sessionStorage.setItem("__gameId", item.id);

      if (code === "zr") {
        getLoginUrlApi({
          company_id: item.id
        }, "post").then(res => {
          toast.close();

          if (res.code === 0 && res.data) {
            router.replace({
              path: "/iframe",
              query: {
                title: item.name,
                url: res.data.url
              }
            }); // location.href = res.data.url
          }
        }).catch(() => {
          toast.close();
        });
      } else if (code === "cp") {
        cpGetLoginUrlApi({
          company_id: item.id
        }, "post").then(res => {
          toast.close();

          if (res.code === 0 && res.data) {
            // router.replace({
            //   path: "/iframe",
            //   query: {
            //     title: item.name,
            //     url: res.data.url,
            //   },
            // });
            location.href = res.data.url;
          }
        }).catch(() => {
          toast.close();
        });
      } else if (code === "dz") {
        qyGetLoginUrlApi({
          company_id: item.id
        }, "post").then(res => {
          toast.close();

          if (res.code === 0 && res.data) {
            router.replace({
              path: "/iframe",
              query: {
                title: item.name,
                url: res.data.url
              }
            }); // location.href = res.data.url;
          }
        }).catch(() => {
          toast.close();
        });
      }
    };

    const navClick = index => {
      active.value = index;
    };

    const navClick1 = index => {
      active1.value = index;
    };

    const more = () => {};

    return (_ctx, _cache) => {
      const _component_my_image = _resolveComponent("my-image");

      const _component_van_col = _resolveComponent("van-col");

      const _component_van_row = _resolveComponent("van-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_component_my_image, {
        key: _unref(store).state.userInfo.top_image,
        url: _unref(store).state.userInfo.top_image
      }, null, 8, ["url"]))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, "账户：" + _toDisplayString(_unref(store).state.userInfo.username), 1), _createElementVNode("p", null, "余额：" + _toDisplayString(_unref(store).state.userInfo.money), 1)])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => navClick(index),
          key: index,
          class: _normalizeClass(["item", active.value === index ? 'active' : ''])
        }, [_createElementVNode("div", _hoisted_9, [(_openBlock(), _createBlock(_component_my_image, {
          key: item.logo,
          url: item.logo
        }, null, 8, ["url"]))]), _createTextVNode(" " + _toDisplayString(item.name), 1)], 10, _hoisted_8);
      }), 128)), _hoisted_10, _hoisted_11]), _createElementVNode("div", _hoisted_12, [list.value.length ? (_openBlock(), _createBlock(_component_van_row, {
        key: 0,
        gutter: "20"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value[active.value].data, item => {
          return _openBlock(), _createBlock(_component_van_col, {
            span: "8",
            key: item
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "game-item",
              onClick: $event => getLoginUrl(item, list.value[active.value].code)
            }, [_createElementVNode("div", _hoisted_14, [(_openBlock(), _createBlock(_component_my_image, {
              key: item.image,
              url: item.image
            }, null, 8, ["url"]))])], 8, _hoisted_13)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })) : _createCommentVNode("", true), list.value.length && list.value[active.value].data.length === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_15, " 暂无数据 ")) : _createCommentVNode("", true), _createElementVNode("p", {
        class: "more",
        onClick: more
      }, "---暂无更多---")]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => navClick1(0)),
        class: _normalizeClass(["item", active1.value === 0 ? 'active' : ''])
      }, [_createElementVNode("div", _hoisted_17, [(_openBlock(), _createBlock(_component_my_image, {
        key: list1.value.logo,
        url: list1.value.logo
      }, null, 8, ["url"]))]), _createTextVNode(" " + _toDisplayString(list1.value.name), 1)], 2), _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => navClick1(0)),
        class: _normalizeClass(["item", active1.value === 1 ? 'active' : ''])
      }, " 待开放 ", 2), _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = $event => navClick1(0)),
        class: _normalizeClass(["item", active1.value === 2 ? 'active' : ''])
      }, " 待开放 ", 2)]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_row, {
        gutter: "20"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list1.value.data, item => {
          return _openBlock(), _createBlock(_component_van_col, {
            span: "8",
            key: item
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "game-item",
              onClick: $event => getLoginUrl(item, list1.value.code)
            }, [_createElementVNode("div", _hoisted_20, [(_openBlock(), _createBlock(_component_my_image, {
              key: item.image,
              url: item.image
            }, null, 8, ["url"]))])], 8, _hoisted_19)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _createElementVNode("p", {
        class: "more",
        onClick: more
      }, "---暂无更多---")]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = $event => navClick1(0)),
        class: _normalizeClass(["item", active1.value === 0 ? 'active' : ''])
      }, [_createElementVNode("div", _hoisted_22, [(_openBlock(), _createBlock(_component_my_image, {
        key: list2.value.logo,
        url: list2.value.logo
      }, null, 8, ["url"]))]), _createTextVNode(" " + _toDisplayString(list2.value.name), 1)], 2), _createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = $event => navClick1(0)),
        class: _normalizeClass(["item", active1.value === 1 ? 'active' : ''])
      }, " 待开放 ", 2), _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = $event => navClick1(0)),
        class: _normalizeClass(["item", active1.value === 2 ? 'active' : ''])
      }, " 待开放 ", 2)]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_van_row, {
        gutter: "20"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list2.value.data, item => {
          return _openBlock(), _createBlock(_component_van_col, {
            span: "8",
            key: item
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "game-item",
              onClick: $event => getLoginUrl(item, list2.value.code)
            }, [_createElementVNode("div", _hoisted_25, [(_openBlock(), _createBlock(_component_my_image, {
              key: item.image,
              url: item.image
            }, null, 8, ["url"]))])], 8, _hoisted_24)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _createElementVNode("p", {
        class: "more",
        onClick: more
      }, "---暂无更多---")])])]);
    };
  }

};